import { mixins, mods, RequiredMods, theme } from '@approvalmax/theme';
import { StatusLabelProps } from '@approvalmax/ui/src/components/StatusLabel/StatusLabel.types';
import { StyledMods } from '@styled-kit/mods';
import styled, { css } from 'styled-components';

export const Label = styled.div`
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
`;

const rootColorMixin = (color: RequiredMods['color']) => css`
    color: ${theme.color[color]};

    ${mods.bordered.true`
        box-shadow-color: ${theme.color[color]};
        border-color: ${theme.color[color]};
    `};
`;

const rootSizeMixin = (
    fontSize: RequiredMods['fontSize'],
    fontWeight: RequiredMods['fontWeight'],
    paddingVertical: RequiredMods['spacing'],
    paddingHorizontal: RequiredMods['spacing'],
    iconSize: RequiredMods['iconSize'],
    gap: RequiredMods['spacing'],
    borderWidth: RequiredMods['borderWidth']
) => css`
    padding: ${paddingVertical}px ${paddingHorizontal}px;
    column-gap: ${gap}px;
    border-width: ${borderWidth}px;
    border-style: solid;

    ${Label} {
        ${mixins.font('label', fontSize, fontWeight)};
    }

    svg {
        ${mixins.iconSize(iconSize)};
    }
`;

export const Root = styled.div<StyledMods<Pick<StatusLabelProps, 'bordered' | 'size' | 'color'>>>`
    display: inline-flex;
    align-items: center;
    border-color: transparent;
    cursor: default;

    ${mods.color.green100(rootColorMixin('green100'))};
    ${mods.color.brandDext90(rootColorMixin('brandDext90'))};
    ${mods.color.brandXero100(rootColorMixin('brandXero100'))};
    ${mods.color.midnight80(rootColorMixin('midnight80'))};
    ${mods.color.red100(rootColorMixin('red100'))};
    ${mods.color.midnight60(rootColorMixin('midnight60'))};

    ${mods.size.small(rootSizeMixin('small', 'bold', 0, 0, 12, 2, 0))};
    ${mods.size.medium(rootSizeMixin('medium', 'medium', 0, 0, 16, 4, 0))};
    ${mods.size.large(rootSizeMixin('large', 'medium', 0, 0, 20, 4, 0))};

    ${mods.bordered.true`
        ${mods.size.small(rootSizeMixin('xsmall', 'regular', 4, 8, 12, 2, 1))};
        ${mods.size.medium(rootSizeMixin('small', 'medium', 8, 12, 16, 4, 2))};
        ${mods.size.large(rootSizeMixin('large', 'medium', 8, 12, 20, 4, 2))};
    `}
`;
